export const decodePayload = (payload: Uint8Array): string => {
  const decoded = new TextDecoder().decode(payload);
  return formatServiceCallPayload(decoded);
};

const formatServiceCallPayload = (payload: string): string => {
  let json: unknown;
  try {
    json = JSON.parse(payload);
  } catch (e) {
    // If payload is not valid JSON, return it as-is or indicate error
    return payload;
  }

  if (typeof json === 'string') {
    return json;
  }

  return JSON.stringify(json, null, 2);
};
